import React from 'react';
import { createTheme } from '@mui/material/styles';
import { useMediaQuery } from '@mui/material';

const getDesignTokens = (mode) => ({
  palette: {
    mode,
    ...(mode === 'light'
      ? {
          // palette values for light mode
          primary: { main: '#256d00' },
          onPrimary: { main: '#ffffff' },
          primaryContainer: { main: '#7dff45' },
          onPrimaryContainer: { main: '#062100' },
          secondary: { main: '#55624c' },
          onSecondary: { main: '#ffffff' },
          secondaryContainer: { main: '#d8e7cb' },
          onSecondaryContainer: { main: '#131f0d' },
          tertiary: { main: '#386667' },
          onTertiary: { main: '#ffffff' },
          tertiaryContainer: { main: '#bbebec' },
          onTertiaryContainer: { main: '#002021' },
          error: { main: '#ba1a1a' },
          onError: { main: '#ffffff' },
          errorContainer: { main: '#ffdad6' },
          onErrorContainer: { main: '#410002' },
          background: { default: '#fdfdf6', paper: '#fdfdf6' },
          onBackground: { main: '#1a1c18' },
          surface: { main: '#fdfdf6' },
          onSurface: { main: '#1a1c18' },
          surfaceVariant: { main: '#dfe4d7' },
          onSurfaceVariant: { main: '#43483e' },
          outline: { main: '#73796d' },
          shadow: { main: '#000000' },
          inverseSurface: { main: '#2f312d' },
          inverseOnSurface: { main: '#f1f1ea' },
          inversePrimary: { main: '#55e300' },
        }
      : {
          // palette values for dark mode
          primary: { main: '#55e300' },
          onPrimary: { main: '#0f3900' },
          primaryContainer: { main: '#1a5200' },
          onPrimaryContainer: { main: '#7dff45' },
          secondary: { main: '#bccbb0' },
          onSecondary: { main: '#283421' },
          secondaryContainer: { main: '#3e4a36' },
          onSecondaryContainer: { main: '#d8e7cb' },
          tertiary: { main: '#a0cfd0' },
          onTertiary: { main: '#003738' },
          tertiaryContainer: { main: '#1e4e4f' },
          onTertiaryContainer: { main: '#bbebec' },
          error: { main: '#ffb4ab' },
          onError: { main: '#690005' },
          errorContainer: { main: '#93000a' },
          onErrorContainer: { main: '#ffb4ab' },
          background: { default: '#1a1c18', paper: '#1a1c18' },
          onBackground: { main: '#e3e3dc' },
          surface: { main: '#1a1c18' },
          onSurface: { main: '#e3e3dc' },
          surfaceVariant: { main: '#43483e' },
          onSurfaceVariant: { main: '#c3c8bb' },
          outline: { main: '#8d9287' },
          shadow: { main: '#000000' },
          inverseSurface: { main: '#e3e3dc' },
          inverseOnSurface: { main: '#2f312d' },
          inversePrimary: { main: '#256d00' },
          no:{paper: ''},
        }),
  },
  shape: {
    borderRadius: 16,
  },
  typography: {
    fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: 20,
          textTransform: 'none',
          fontWeight: 'bold',
        },
      },
    },
    MuiFab: {
      styleOverrides: {
        root: {
          borderRadius: 16,
        },
      },
    },
  },
});

export const useAppTheme = () => {
  const prefersDarkMode = useMediaQuery('(prefers-color-scheme: dark)');
  const [themeMode, setThemeMode] = React.useState(localStorage.getItem('themeMode') || 'system');

  const theme = React.useMemo(() => {
    const mode = themeMode === 'system' ? (prefersDarkMode ? 'dark' : 'light') : themeMode;
    return createTheme(getDesignTokens(mode));
  }, [prefersDarkMode, themeMode]);

  const setTheme = (mode) => {
    localStorage.setItem('themeMode', mode);
    setThemeMode(mode);
  };

  return [theme, setTheme];
};
